// @flow
import React, { useContext } from 'react';
import { SPOrgContext } from '@streaming-projects/orgs/contexts/SPOrgContext';
import { SecondaryTopBar } from '@components/breadcrumbs/SecondaryTopBar';
import { getSPOrgBreadcrumbs } from '@streaming-projects/utils';

export const SPOrgBreadcrumbs = () => {
  const spOrgData = useContext(SPOrgContext);
  return (
    <SecondaryTopBar
      sectionsToShow={getSPOrgBreadcrumbs(spOrgData)}
      showLastUpdatedMessage={false}
    />
  );
};
